<template>

    <div class="grid">
        <div class="col-12">
            <p class="text-600 text-sm mb-2">{{ $utils.formatCurrency(value[0]) }} - {{ $utils.formatCurrency(value[1])
                }}</p>
            <Slider v-model="value" range class="w-full" :min="min" :max="max" />
            
        </div>
        <div class="col-6">
            <InputNumber v-model="value[0]" inputId="locale-user" :minFractionDigits="2" inputClass="w-full" />
            
        </div>
        <div class="col-6">
            <InputNumber v-model="value[1]" inputId="locale-user" :minFractionDigits="2" inputClass="w-full" />
        </div>
    </div>


</template>

<script>


export default {
    name: "PrecoFiltro",
    props: {
        min: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: 1000
        }
    },
    emits: [
        'update:value'
    ],
    data: function () {
        return {

            value: [20, 80]

        }
    },
    watch: {
        value: {
            handler(newValue) {
                this.$emit('update:value', newValue);
            },
            deep: true
        },
        min: {
            handler(newValue) {
                if (typeof this.value[0] === 'number') {
                    this.value[0] = newValue;
                }
            },
            immediate: true
        },
        max: {
            handler(newValue) {
                if (typeof this.value[1] === 'number') {
                    this.value[1] = newValue;
                }
            },
            immediate: true
        }
    }
}
</script>

<style lang="scss" scoped></style>